import ISceneModel from '@/models/scene-model';
import SentrySingleton from '@/singletons/sentry-singleton';

export default class RenderService {
    render(sceneModel: ISceneModel): void {
        try {
            if (sceneModel.postprocessing) {
                if (sceneModel.composer) {
                    sceneModel.composer.render()
                }
            } else {
                if (sceneModel.renderer) {
                    sceneModel.renderer.render(sceneModel.scene, sceneModel.camera)
                }
            }
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }
    }

    setRenderSize(sceneModel: ISceneModel, width: number, height: number) {
        try {
            sceneModel.camera.aspect = width / height
            sceneModel.camera.updateProjectionMatrix()
            sceneModel.renderer.setSize(width, height)
            if (sceneModel.postprocessing) {
                sceneModel.composer!.setSize(width, height)
                sceneModel.fxaaPass!.uniforms['resolution'].value.set(1 / width, 1 / height)
            }
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }
    }

    saveDataURL(uri: string, filename: string) {
        try {
            var link = document.createElement('a')
            if (typeof link.download === 'string') {
                link.href = uri
                link.download = filename
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            } else {
                window.open(uri)
            }
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }
    }
}